// extracted by mini-css-extract-plugin
module.exports = {"normalPlayIcon":"ViewStoryArrowComponentStyles__normalPlayIcon icon-Play","standardSize":"ViewStoryArrowComponentStyles__standardSize font-size--button--medium icon","scalingSize":"ViewStoryArrowComponentStyles__scalingSize font-size--play--scaling"};
    if(module.hot) {
      // 1790535734242
      var cssReload = require("/var/lib/jenkins/workspace/Player_master/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  